/* eslint-disable no-restricted-syntax */
import { ICostFormulaGroup, ECostFormulaType, ICostFormula } from 'store/cost-formulas/types';
import { IPrice } from 'store/field-options/types';

// pass request type, available formula groups, and name of the cost formula
// returns the formula string if it exists, or any empty string

function checkCostFormulaGroupName(availableCostFormulaGroup: ICostFormulaGroup, name: string) {
  return name === availableCostFormulaGroup.name;
}

function checkFormulaExist(costFormulas: ICostFormula[]) {
  return !costFormulas || costFormulas.length === 0;
}

function getCostFormulas(costFormulas: ICostFormula[], indexFound: number) {
  return indexFound > -1 ? costFormulas[indexFound].formula : '';
}

// find and return formula of type `type`
function processCostFormulas(costFormulas: ICostFormula[], type: ECostFormulaType) {
  let indexFound = -1;
  let indexCount = -1;
  for (const costFormula of costFormulas) {
    indexCount += 1;
    if (costFormula.type === type) {
      indexFound = indexCount;
      break;
    }
  }
  return indexFound;
}

export function getMfgCostFormulaByName(
  type: ECostFormulaType,
  availableCostFormulaGroups: ICostFormulaGroup[],
  name?: string
): string {
  if (!name) {
    return '';
  }

  for (const availableCostFormulaGroup of availableCostFormulaGroups) {
    // found match
    if (checkCostFormulaGroupName(availableCostFormulaGroup, name)) {
      // ensure formulas exist before looping
      const costFormulas = availableCostFormulaGroup.formulas;
      if (checkFormulaExist(costFormulas)) {
        return '';
      }

      return getCostFormulas(costFormulas, processCostFormulas(costFormulas, type));
    }
  }
  return '';
}

export function parseFloatsInOtherBatnas(otherBatnas: IPrice[]) {
  if (!otherBatnas) {
    return [];
  }
  return otherBatnas.map((otherBatna: IPrice) => ({
    ...otherBatna,
    costFreight: parseFloat(otherBatna.costFreight.toString()),
    costFixed: parseFloat(otherBatna.costFixed?.toString() ?? ''),
    costIncInventory: parseFloat(otherBatna.costIncInventory?.toString() ?? ''),
    costTransitDays: parseFloat(otherBatna.costTransitDays?.toString() ?? ''),
    costReimbursed: parseFloat(otherBatna.costReimbursed?.toString() ?? ''),
  }));
}
